import { BehaviorSubject, interval, Subject } from 'rxjs';
import { takeUntil, takeWhile, tap } from 'rxjs/operators';

const FAKE_PROGRESS_INTERVAL = 1000;
const FAKE_PROGRESS_SLOWDOWN_COEFFICIENT = 0.5;

export class FakeProgress {
  public loaderValue$ = new BehaviorSubject<number>(0);
  private stop$ = new Subject();
  private fakeProgressY = 0;
  private fakeProgressX = 0;
  private fakeProgressDuration: number;
  private fakeProgressLimit: number;

  private fakeProgressFun = (x) => 1 - 1 / Math.pow(FAKE_PROGRESS_SLOWDOWN_COEFFICIENT * x + 1, 2);

  constructor(fakeProgressDurationMs: number, fakeProgressLimitPercent: number) {
    this.fakeProgressDuration = fakeProgressDurationMs;
    this.fakeProgressLimit = fakeProgressLimitPercent;
  }

  public start(startTimeMs = 0) {
    this.fakeProgressX = startTimeMs / this.fakeProgressDuration;
    this.fakeProgressY = this.fakeProgressFun(this.fakeProgressX);

    interval(FAKE_PROGRESS_INTERVAL)
      .pipe(
        takeWhile(() => this.fakeProgressY < this.fakeProgressLimit),
        takeUntil(this.stop$),
        tap(() => (this.fakeProgressX += FAKE_PROGRESS_INTERVAL / this.fakeProgressDuration)),
        tap(() => (this.fakeProgressY = this.fakeProgressLimit * this.fakeProgressFun(this.fakeProgressX))),
        tap(() => this.loaderValue$.next(Math.round(this.fakeProgressY))),
      )
      .subscribe();
  }

  public stop() {
    this.stop$.next(true);
  }
}
